module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "projectSettingsNav",
    staticClass: "md-left"
  }, [_c('md-dialog-confirm', {
    ref: "deleteProjectDialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.getConfirmContent(),
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.deleteProjectConfirm
    }
  }), _vm._v(" "), _c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Project Settings")])], 1), _vm._v(" "), (_vm.ownerUID === _vm.user.uid) ? _c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.open($event)
      }
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.updateTitle
    }
  }, [_vm._v("Rename")])], 1)]) : _c('md-layout', {
    attrs: {
      "md-column": "",
      "md-flex": "90",
      "md-flex-offset": "5"
    }
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-2"
  }, [_vm._v(_vm._s(_vm.project.title))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21aae4ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project-settings/nav.vue
// module id = 638
// module chunks = 2